import React from 'react'
import ReactDatePicker, { DatePickerProps } from 'react-date-picker'

import './DatePicker.scss'

export const DatePicker = (props: DatePickerProps) => <ReactDatePicker className="date-picker" {...props} />
